import { lazy } from 'react';
import { Route } from 'react-router-dom';

const ProductCategories = lazy(() => import('../components/Product-Main/ProductCategories'));
const BrandsPage = lazy(() => import('../components/brandsPage'));
const BrandDetailPage = lazy(() => import('../components/brandsPage/BrandDetailPage'));
const Pincode = lazy(() => import('../components/pincode/index.jsx'));
const KBSellerScreen = lazy(() => import('../components/kb-experiment/pages/SellerScreen'));
const KBPlp = lazy(() => import('../components/kb-experiment/pages/PLP'));
const KMSellerScreen = lazy(() => import('../components/kirana-mall/pages/SellerScreen'));
const KMPlp = lazy(() => import('../components/kirana-mall/pages/PLP'));

const productRoutes = (
	<>
		<Route path="/" element={<ProductCategories />} />
		<Route path="/brand" element={<BrandsPage />} />
		<Route path="/brand/details/:id" element={<BrandDetailPage />} />
		<Route path="/pincode/:brandID" element={<Pincode />} />
		<Route path="/kb-experiment/seller" element={<KBSellerScreen />} />
		<Route path="/kb-experiment/plp" element={<KBPlp />} />
		<Route path="/kirana_mall/seller" element={<KMSellerScreen />} />
		<Route path="/kirana_mall/plp" element={<KMPlp />} />
	</>
);

export default productRoutes;
